import type { IAssignFlow, IAssignFlowResult } from './types'

export class InboxAccessFlow implements IAssignFlow {
  constructor(
    private _getMemberId: () => number | null,
    private _addMembersToExistingInbox: (memberId: number, inboxIds: number[]) => Promise<boolean>,
    private _onSuccess: () => void
  ) {}

  shouldIncludeMemberInNewInbox = (): boolean => true

  handleExistingInboxAssign = async (inboxIds: number[]): Promise<IAssignFlowResult> => {
    const memberId = this._getMemberId()
    if (!memberId) return { success: false }

    const success = await this._addMembersToExistingInbox(memberId, inboxIds)
    if (success) {
      this._onSuccess()
    }
    return { success }
  }

  handleNewInboxCreated = async (): Promise<IAssignFlowResult> => {
    this._onSuccess()
    return { success: true }
  }

  getExistingInboxSuccessToast = (): string => 'Inbox access approved'

  getNewInboxSuccessToast = (): string => 'Inbox access approved'
}
